/*@ngInject*/
const LabelController = function ($scope, $controller) {

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}));

    this.$onInit = function () {
        this.onInit();
        this.setLabelValue();

        const isLabelBold = _.toLower(this.fieldStructure.uiField.labelFontStyle) !== 'normal';
        this.className = isLabelBold ? 'isBold' : '';

        this.updateRequiredIndicator();
    };

    this.$onChanges = function () {
        this.onChanges();
        this.setLabelValue();
        this.updateRequiredIndicator();
    };

    this.setLabelValue = function () {
        const fieldInstance = this.fieldStructure.fieldModel;
        this.labelValue = this.fieldStructure.uiField.displayLabel;

        if (fieldInstance && !_.isNull(fieldInstance.value)) {
            this.labelValue = fieldInstance.value;
        }
    };

    this.updateRequiredIndicator = function () {
        this.fieldStructure.requiredIndicatorLabelConfig.label = null;
        this.hideRequiredIndicator = !this.fieldStructure.requiredIndicatorLabelConfig.required;
    }
};

angular.module('umFormViewer')
    .controller('labelController', LabelController);
